import PropTypes from "prop-types";
import { Button, Col, Container, Row } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import ChevronRight from "@/assets/ChevronRight.svg";
import { LatestBlogCard, Title } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { blog_helper } from "@/helpers/blog_helper";
import { trimText } from "@/functions/trimText";
import CTA from "@/ui/CTA";

export const LatestNews = ({ className, title, button, limit }) => {
  const items = blog_helper.fetch({ limit: limit });

  return (
    <div className={clsx(className, classes.blogs)}>
      <Container className="mw-xxl">
        <Title title={title} />
        <Row className="mb-md-4">
          {items.map(({ title, body, image, publish_date, url_slug }, k) => (
            <Col key={k} xs={12} md={4} className="mb-4 mb-md-0">
              <LatestBlogCard
                className="h-100"
                title={title}
                description={trimText(body)}
                img={image}
                published_at={publish_date}
                href={getRoute("blogPost", { url_slug })}
              />
            </Col>
          ))}
        </Row>
        <div className={classes.blogs__footer}>
          {" "}
          {button
            ? button.map((btn, k) => (
                <CTA
                  key={k}
                  label={btn.label}
                  href={btn.href}
                  className={clsx("mt-4")}
                  variant={btn.variant}
                  target={btn.open_in_new_tab ? "_blank" : undefined}
                />
              ))
            : null}
        </div>
      </Container>
    </div>
  );
};

export default LatestNews;
